import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

import { Col } from 'antd';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var countdownV2MobileHeight = 105;
export var countDownV2DesktopHeight = 180;
var TimeColumn = styled(Col)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: center;\n  min-width: 52px;\n"])));
var DisplayNumber = styled.p(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1;\n  margin-bottom: 0;\n  font-variant-numeric: tabular-nums;\n"])), function (props) {
  var isDisabled = props.isDisabled,
      isCountingDown = props.isCountingDown,
      isAlmostRunOutOfTime = props.isAlmostRunOutOfTime;

  if (isDisabled || !isCountingDown) {
    return styleVariables.colors.gray10;
  }

  return isAlmostRunOutOfTime ? styleVariables.colors.red3 : styleVariables.colors.colorPrimaryBase;
}, function (props) {
  return props.$variant === 'submission' ? '18px' : 'fontSizeMedium';
}, function (props) {
  return props.$variant === 'submission' ? 700 : 400;
});
var TimeDescription = styled.p(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin: 6px 0 0;\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  letter-spacing: ", ";\n  text-transform: ", ";\n"])), function (props) {
  return props.$variant === 'submission' ? '#94A3B8' : styleVariables.colors.gray10;
}, function (props) {
  return props.$variant === 'submission' ? '10px' : 'fontSizeSmall';
}, function (props) {
  return props.$variant === 'submission' ? 600 : 400;
}, function (props) {
  return props.$variant === 'submission' ? '0.08em' : 'normal';
}, function (props) {
  return props.$variant === 'submission' ? 'uppercase' : 'none';
});
var TimerRow = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  width: 100%;\n  gap: 4px;\n"])));
/* Submission: 7-column grid (digit / colon × 3 / digit) keeps labels aligned in narrow sidebars */

var SubmissionTimerRoot = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 100%;\n  overflow: hidden;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 10px minmax(0, 1fr) 10px minmax(0, 1fr) 10px minmax(0, 1fr);\n  justify-items: center;\n  row-gap: 6px;\n"])));
var SubmissionDigit = styled(DisplayNumber)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 18px;\n"])));
var SubmissionUnitLabel = styled.span(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  text-align: center;\n  color: #94a3b8;\n  font-size: 9px;\n  font-weight: 600;\n  line-height: 1.2;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  white-space: nowrap;\n"])));
var SubmissionColon = styled.span(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1;\n  align-self: center;\n  color: ", ";\n  font-variant-numeric: tabular-nums;\n"])), function (props) {
  return props.$isAlmostRunOutOfTime ? styleVariables.colors.red3 : props.$isActive ? styleVariables.colors.colorPrimaryBase : styleVariables.colors.gray10;
});

var formatCountdownSegment = function formatCountdownSegment(countdownTime) {
  return countdownTime && parseInt(countdownTime) >= 0 ? parseInt(countdownTime).toString().padStart(2, '0') : '00';
};
/** Short unit labels fit narrow submission sidebars (e.g. DAY → D). */


var abbreviateSubmissionUnitLabel = function abbreviateSubmissionUnitLabel(label) {
  var trimmed = label.trim();
  if (!trimmed) return '';
  return trimmed.charAt(0);
};

var TimeColumnComponent = function TimeColumnComponent(props) {
  var isDisabled = props.isDisabled,
      isCountingDown = props.isCountingDown,
      isAlmostRunOutOfTime = props.isAlmostRunOutOfTime,
      countdownTime = props.countdownTime,
      label = props.label,
      variant = props.variant;
  var formattedTime = formatCountdownSegment(countdownTime);
  return /*#__PURE__*/_jsxs(TimeColumn, {
    children: [/*#__PURE__*/_jsx(DisplayNumber, {
      isDisabled: isDisabled,
      isCountingDown: isCountingDown,
      isAlmostRunOutOfTime: isAlmostRunOutOfTime,
      $variant: variant,
      children: formattedTime
    }), /*#__PURE__*/_jsx(TimeDescription, {
      $variant: variant,
      children: label
    })]
  });
};

var formatCountDownTime = function formatCountDownTime(time) {
  var duration = moment.duration(time);
  var totalDays = Math.floor(duration.asDays());
  var totalHours = duration.hours();
  var totalMinutes = duration.minutes();
  var totalSeconds = duration.seconds();
  return {
    countdownDays: totalDays.toString(),
    countdownHours: totalHours.toString(),
    countdownMinutes: totalMinutes.toString(),
    countdownSeconds: totalSeconds.toString()
  };
};

export var CountDownTimerV2 = function CountDownTimerV2(_ref) {
  var label = _ref.label,
      remainTime = _ref.remainTime,
      isDisabled = _ref.isDisabled,
      onSetElapsedTime = _ref.onSetElapsedTime,
      isCountingDown = _ref.isCountingDown,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant;

  var _useState = useState(remainTime ? remainTime * 1000 : 0),
      elapsedTime = _useState[0],
      setElapsedTime = _useState[1];

  var intervalIdRef = useRef(null);
  useEffect(function () {
    setElapsedTime(remainTime ? Math.max(remainTime, 0) * 1000 : 0);
  }, [remainTime]);
  useEffect(function () {
    var canTick = isCountingDown && typeof remainTime === 'number' && Number.isFinite(remainTime) && remainTime > 0;

    if (canTick) {
      intervalIdRef.current = setInterval(function () {
        setElapsedTime(Math.max(remainTime - 1, 0) * 1000);
        onSetElapsedTime === null || onSetElapsedTime === void 0 ? void 0 : onSetElapsedTime();
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }, 1000);
    } else if (intervalIdRef.current) {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null;
    }

    return function () {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
      }
    };
  }, [isCountingDown, onSetElapsedTime, remainTime]);
  var countdownTime = formatCountDownTime(elapsedTime);
  var isAlmostRunOutOfTime = useMemo(function () {
    if (!countdownTime) return false;
    return parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownDays) === 0 && parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownHours) === 0 && parseInt(countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownMinutes) < 5;
  }, [countdownTime]);
  var isActive = !isDisabled && isCountingDown;
  var segments = [{
    value: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownDays,
    unitLabel: label.day
  }, {
    value: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownHours,
    unitLabel: label.hour
  }, {
    value: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownMinutes,
    unitLabel: label.minute
  }, {
    value: countdownTime === null || countdownTime === void 0 ? void 0 : countdownTime.countdownSeconds,
    unitLabel: label.second
  }];

  if (variant === 'submission') {
    var digitCells = [];
    var labelCells = [];
    segments.forEach(function (segment, index) {
      digitCells.push( /*#__PURE__*/_jsx(SubmissionDigit, {
        isDisabled: isDisabled,
        isCountingDown: isCountingDown,
        isAlmostRunOutOfTime: isAlmostRunOutOfTime,
        $variant: variant,
        children: formatCountdownSegment(segment.value)
      }, "digit-".concat(segment.unitLabel)));
      labelCells.push( /*#__PURE__*/_jsx(SubmissionUnitLabel, {
        children: abbreviateSubmissionUnitLabel(segment.unitLabel)
      }, "label-".concat(segment.unitLabel)));

      if (index < segments.length - 1) {
        digitCells.push( /*#__PURE__*/_jsx(SubmissionColon, {
          $isActive: isActive,
          $isAlmostRunOutOfTime: isAlmostRunOutOfTime,
          "aria-hidden": true,
          children: ":"
        }, "colon-".concat(segment.unitLabel)));
        labelCells.push( /*#__PURE__*/_jsx("span", {
          "aria-hidden": true
        }, "colon-spacer-".concat(segment.unitLabel)));
      }
    });
    return /*#__PURE__*/_jsx(SubmissionTimerRoot, {
      children: [].concat(digitCells, labelCells)
    });
  }

  return /*#__PURE__*/_jsx(TimerRow, {
    children: segments.map(function (segment) {
      return /*#__PURE__*/_jsx(TimeColumnComponent, {
        isCountingDown: isCountingDown,
        isAlmostRunOutOfTime: isAlmostRunOutOfTime,
        countdownTime: segment.value,
        label: segment.unitLabel,
        isDisabled: isDisabled,
        variant: variant
      }, segment.unitLabel);
    })
  });
};